import phonesImg from '../image/ShopByCategory/phones.webp';
import tabletsImg from '../image/ShopByCategory/tablets.webp';
import accessoriesImg from '../image/ShopByCategory/accessories.webp';

export const CategoryList = [
  { src: phonesImg, alt: 'Phones', title: 'mobilePhones', link: 'phones' },
  { src: tabletsImg, alt: 'Tablets', title: 'tablets', link: 'tablets' },
  {
    src: accessoriesImg,
    alt: 'Accessories',
    title: 'accessories',
    link: 'accessories',
  },
];
